import React, { Component, Fragment, lazy } from 'react';
import { Redirect, Switch } from 'react-router-dom';
import PropsRoute from '../../hoc/PropsRoute/PropsRoute';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { nbsApiEmailLogin } from '../../store/actions/emailLogin';
import {
  getSessionInitCookie,
  setSessionInitCookie,
} from '../../store/actions/session';
import URLSearchParams from 'url-search-params';

import paths from '../../constants/paths';
import PasswordRecoveryContainer from '../Auth/PasswordRecovery/PasswordRecoveryContainer';
import NewPasswordContainer from '../Auth/PasswordRecovery/NewPassword/NewPasswordContainer';
import ContactUsContainer from '../ContactUs/ContactUsContainer';
import HandlingUserData from '../Modals/HandlingUserData/HandlingUserData';
import LogoutContainer from '../Logout/Logout';
import { setMailingIdPromo } from '../../store/actions/paymentData';
import { nbsApiTrackAffiliateClick } from '../../store/actions/trackAffiliateClick';
import { nbsApiMyLocation } from '../../store/actions/myLocation';
import {
  extractAffiliateParamsFromUrl,
  setAffiliateParams,
  prepareAffiliateParams,
  setLandingId,
  getLandingId,
} from '../../assets/helpers/affiliateHelper';
import { setItemToStorage } from '../../assets/helpers/localStorageHelper';
import SuspenseFallback from '../../hoc/SuspenseFallback/SuspenseFallback';
import strings from '../../assets/localization';
import { resetAccountStatus } from '../../store/actions/resetAccountStatus';
import AlertError from '../../components/Auth/AlertError/AlertError';
import { nbsApiConfirmEmail } from '../../store/actions/confirmEmail';

// http://localhost:3000/?profile_id=5a04c712c7cdef56a9f63266&force_login_token=1246f09f-5898-41ff-9d1c-632db06f9695&utm_campaign=flirt_email&utm_medium=email&utm_source=free
// http://localhost:3000/?profile_id=5a04c712c7cdef56a9f63266&utm_campaign=flirt_email&utm_medium=email&utm_source=free
// https://dev.hippie.dating/go-vip?utm_campaign=new_message&utm_medium=email&utm_source=free
// http://localhost:3000/go-vip?utm_campaign=new_message&utm_medium=email&utm_source=free
// localhost:3000/signup?aff_pg=PPU&aff_id=ppcgoogle&aff_cp=BikersDating+-+Search&aff_kw=%2Bbiker%20dating&aff_plmt=Search&aff_src=c&aff_adg=BikersDating+-+Female+-+Tier1/signup?aff_pg=PPU&aff_id=ppcgoogle&aff_cp=&aff_adg=&aff_kw=%2Bbiker%20dating-b&aff_plmt=1t3&aff_src=g-c&gclid=Cj0KCQjwh8jrBRDQARIsAH7BsXdslrxbPn2XSS6pDhF-1_ay0hu1Y5mLWeST9PKY9N5nQCtvr4q9DUwaAq0QEALw_wcB
// http://localhost:3000/deep-link.php?force_login_token=e6305763-ca2f-4980-af0a-c9be1d0b48c7-643e6966-3ee2-4882-a82b-5073cfb2296c-950bd49b-0662-4855-a615-ef97b623fe8d-bc2b9549-8252-4f3d-8da0-2ca5c6bba9c2-6ff01f66-2612-4f06-849a-954a5bfd79aa-8e50aa2e-5c3a-4ee4-8aaf-e4b7aeca3911
// https://dev.hippie.dating/deep-link.php?force_login_token=a6034a9e-b385-41dd-bd95-76f5252a12fd-4c8753a8-858b-4bed-b6a8-5a7403bcd9cc-9c03894e-bf0f-4056-b816-c36152b54503-9f01dd7c-55de-4b74-afed-2fe6070099f4-28702764-320c-4c48-b57f-e06bc216b005-d4c3b33c-5e16-41b9-a15b-decb93a8ac64
// http://localhost:3000/?refund_transaction_id=111122212111&force_login_token=641a9560-0441-48c5-99a4-2de106f052e8-25b3438f-7e15-477b-9578-7c5047944536-0b4919e8-419a-4813-bca4-da55e07f1b60-e604ea2d-b351-43f9-a385-1f70d694e4ba-dad670fc-985a-42d7-8d75-eaa1f798084a-66d8579c-0d9f-4073-9b13-bd2fa5016bd4
// http://localhost:3000/deep-link.php?refund_transaction_id=619e6df07f459a40c2f491bf&utm_campaign=alt_cc_refund&utm_medium=email&utm_source=paid&force_login_token=48e9bb52-e853-4fed-b6de-29845f3a84b4-31fc7fb8-e64f-4661-b89a-46499301ffb3-b46537f9-1139-4c1b-ab6c-78efbd2216d7-4920c0a1-cd7b-4ee1-84c7-bf208322a627-9a7909f2-fc68-4009-acd8-f5d6b534ab2e-e0be1559-4dd3-4e15-86bb-0910d48c7f77
// http://localhost:3000/?refund_transaction_id=619e6df07f459a40c2f491bf&utm_campaign=alt_cc_refund&utm_medium=email&utm_source=paid&force_login_token=48e9bb52-e853-4fed-b6de-29845f3a84b4-31fc7fb8-e64f-4661-b89a-46499301ffb3-b46537f9-1139-4c1b-ab6c-78efbd2216d7-4920c0a1-cd7b-4ee1-84c7-bf208322a627-9a7909f2-fc68-4009-acd8-f5d6b534ab2e-e0be1559-4dd3-4e15-86bb-0910d48c7f77
// https://www.hippie.dating/?account_confirmation_token=b60ea32a8dd74823886c8afee1f6ecfc&utm_campaign=confirm_email&utm_medium=email&utm_source=free&sendid=nb_confirm_240117
// http://localhost:3000/deep-link.php?account_confirmation_token=1e1d81857772435bb00ae27ecc3d2dba&utm_campaign=confirm_email&utm_medium=email&utm_source=free&force_login_token=NFLA_eyJ1aWQiOiI2NWE5NTMxZjFhNjVmMjZkY2VlNTE0NTEiLCJkYXRlIjoxNzA1NTk1NjgwLCJzaWduYXR1cmVfdHlwZSI6InNoYTI1NiIsInNpZ25hdHVyZSI6IjkxY2JjOTEzYTE5ZWQzMjExZjg3OTNiZTkzMDBmN2U0YTUzODY0YWM0NTgwNmUwNmVmMmQ2MjIwNjE3MGU1MDcifQ%3D%3D&sendid=nb_p_confirm_240118

//https://dev.hippie.dating/?account_confirmation_token=1e1d81857772435bb00ae27ecc3d2dba&utm_campaign=confirm_email&utm_medium=email&utm_source=free&sendid=nb_p_confirm_240118
// https://dev.hippie.dating/deep-link.php?account_confirmation_token=1e1d81857772435bb00ae27ecc3d2dba&utm_campaign=confirm_email&utm_medium=email&utm_source=free&force_login_token=NFLA_eyJ1aWQiOiI2NWE5NTMxZjFhNjVmMjZkY2VlNTE0NTEiLCJkYXRlIjoxNzA1NTk1NjgwLCJzaWduYXR1cmVfdHlwZSI6InNoYTI1NiIsInNpZ25hdHVyZSI6IjkxY2JjOTEzYTE5ZWQzMjExZjg3OTNiZTkzMDBmN2U0YTUzODY0YWM0NTgwNmUwNmVmMmQ2MjIwNjE3MGU1MDcifQ%3D%3D&sendid=nb_p_confirm_240118
// http://localhost:3000/deep-link.php?force_login_token=NFLA_eyJ1aWQiOiI2NWE5NTMxZjFhNjVmMjZkY2VlNTE0NTEiLCJkYXRlIjoxNzA1NTk1NjgwLCJzaWduYXR1cmVfdHlwZSI6InNoYTI1NiIsInNpZ25hdHVyZSI6IjkxY2JjOTEzYTE5ZWQzMjExZjg3OTNiZTkzMDBmN2U0YTUzODY0YWM0NTgwNmUwNmVmMmQ2MjIwNjE3MGU1MDcifQ%3D%3D&sendid=nb_p_confirm_240118

// http://localhost:3000/deep-link.php?account_confirmation_token=1e1d81857772435bb00ae27ecc3d2dba&utm_campaign=confirm_email&utm_medium=email&utm_source=free&force_login_token=NFLA_eyJ1aWQiOiI2NWE5NTMxZjFhNjVmMjZkY2VlNTE0NTEiLCJkYXRlIjoxNzA1NTk1NjgwLCJzaWduYXR1cmVfdHlwZSI6InNoYTI1NiIsInNpZ25hdHVyZSI6IjkxY2JjOTEzYTE5ZWQzMjExZjg3OTNiZTkzMDBmN2U0YTUzODY0YWM0NTgwNmUwNmVmMmQ2MjIwNjE3MGU1MDcifQ%3D%3D&sendid=nb_p_confirm_240118&language=en

const CreateAccount = lazy(() =>
  import(
    /* webpackChunkName: "signup" */ '../Auth/CreateAccount/CreateAccountContainer'
  )
);
const CreateAccountI = lazy(() =>
  import(
    /* webpackChunkName: "signupI" */ '../Auth/CreateAccountI/CreateAccountContainer'
  )
);
const CreateAccountJ = lazy(() =>
  import(
    /* webpackChunkName: "signupJ" */ '../Auth/CreateAccountJ/CreateAccountContainer'
  )
);

const CreateAccountA = lazy(() =>
  import(
    /* webpackChunkName: "signupA" */ '../Auth/CreateAccountA/CreateAccountContainer'
  )
);

const CreateAccountB = lazy(() =>
  import(
    /* webpackChunkName: "signupB" */ '../Auth/CreateAccountB/CreateAccountContainer'
  )
);

const LoginLazy = lazy(() =>
  import(/* webpackChunkName: "login" */ '../Auth/Login/LoginContainer')
);

const Index = lazy(() =>
  import(/* webpackChunkName: "home" */ '../IndexPage/IndexPage')
);

const PPModal = lazy(() =>
  import(/* webpackChunkName: "pp" */ '../Modals/Pp/Pp')
);
const ToSModal = lazy(() =>
  import(/* webpackChunkName: "tos" */ '../Modals/Tos/Tos')
);

const Unsubscribe = lazy(() =>
  import(/* webpackChunkName: "Unsubscribe" */ '../Unsubscribe/Unsubscribe')
);

const LazyDeepLinkContainer = lazy(() =>
  import(
    /* webpackChunkName: "deep-link" */ '../../containers/DeepLink/DeepLinkContainer'
  )
);

const Pp = (props) => (
  <SuspenseFallback>
    <PPModal {...props} />
  </SuspenseFallback>
);
const Tos = (props) => (
  <SuspenseFallback>
    <ToSModal {...props} />
  </SuspenseFallback>
);

const CreateAccountContainer = (props) => (
  <SuspenseFallback>
    <CreateAccount {...props} />
  </SuspenseFallback>
);
const CreateAccountContainerI = (props) => (
  <SuspenseFallback>
    <CreateAccountI {...props} />
  </SuspenseFallback>
);
const CreateAccountContainerJ = (props) => (
  <SuspenseFallback>
    <CreateAccountJ {...props} />
  </SuspenseFallback>
);

const CreateAccountContainerA = (props) => (
  <SuspenseFallback>
    <CreateAccountA {...props} />
  </SuspenseFallback>
);

const CreateAccountContainerB = (props) => (
  <SuspenseFallback>
    <CreateAccountB {...props} />
  </SuspenseFallback>
);

const LoginContainer = (props) => (
  <SuspenseFallback>
    <LoginLazy {...props} />
  </SuspenseFallback>
);

const IndexPage = (props) => (
  <SuspenseFallback>
    <Index {...props} />
  </SuspenseFallback>
);

const UnsubscribeContainer = (props) => (
  <SuspenseFallback>
    <Unsubscribe {...props} />
  </SuspenseFallback>
);

const LazyDeepLink = (props) => (
  <SuspenseFallback>
    <LazyDeepLinkContainer {...props} />
  </SuspenseFallback>
);
class MainIndexContainer extends Component {
  state = {
    hasAffiliateParams: false,
    affParams: {},
    showAlert: false,
    message: null,
  };

  delayForceLogin = false;
  robj = {};

  UNSAFE_componentWillMount() {
    // console.log('MAININDEXCONTAINER WILL MOUNT', this.props);
    const { search } = this.props.location;
    const query = new URLSearchParams(search);
    const obj = {};

    if (search.includes('subscription_id')) {
      obj.emailPromo = query.get('subscription_id');
    }

    if (query.get('sendid')) {
      obj.mailingId = query.get('sendid');
    }

    if (query.get('sendid') || query.get('subscription_id')) {
      this.props.setMailingIdPromo(obj);
    }

    if (query.get('force_login_token')) {
      if (query.get('account_confirmation_token')) {
        this.delayForceLogin = true;

        const confirmationToken = query
          .get('account_confirmation_token')
          .toString()
          .trim();
        query.delete('account_confirmation_token');

        // api method
        this.props.nbsApiConfirmEmail({
          confirmationToken,
          device_type: 3,
        });
      }

      const forceLoginToken = query.get('force_login_token').toString().trim();
      query.delete('force_login_token');

      let lpProfileCreated = false;
      if (
        query.get('from-lp') &&
        query.get('from-lp').toString().trim() === 'profile-created'
      ) {
        query.delete('from-lp');
        lpProfileCreated = true;
      }

      const robj = {
        login_type: 'login_token',
        device_type: 3,
        platform: 'web',
        force_login_token: forceLoginToken,
      };

      if (lpProfileCreated) {
        robj.lp_profile_created = lpProfileCreated;
      }

      const landingId = getLandingId();
      if (landingId !== '') {
        const affParams = prepareAffiliateParams({}, true);
        for (let key in affParams) {
          robj[key] = affParams[key];
        }
      }
      // store auth data to local storage in case account is deactivated
      setItemToStorage('__LOGIN_TOKEN_DEACTIVATED__', robj);
      // try to auth with login_token

      if (!getSessionInitCookie()) {
        // console.log('NEMA SESSION INIT COOKIE!!!!!', getSessionInitCookie());
        if (!this.delayForceLogin) {
          this.props.nbsApiEmailLogin(robj);
        } else {
          this.robj = robj;
        }

        setSessionInitCookie();
      } else {
        // console.log('IMA SESSION INIT COOKIE!!!!!!!!!!!!!!!!!!!!', getSessionInitCookie());
        // this.props.history.replace(paths.INDEX);
        this.props.history.replace('/');
      }
    }

    if (search.includes('aff_')) {
      // console.log('IMA AFFIALIATE!!!!', query);
      // const affParams = extractAffiliateParamsFromUrl(search, document.referrer);
      const affParams = extractAffiliateParamsFromUrl(query, document.referrer);
      // console.log('AFFPARAMS ::::::', affParams);
      this.setState({ affParams, hasAffiliateParams: true });
    }

    if (search.includes('profile_id') && search.includes('utm_campaign')) {
      if (query.get('utm_campaign') === 'flirt_email') {
        this.props.history.push(
          `${paths.CHAT_BARE}/${query.get('profile_id')}`
        );
      }
    }

    if (search.includes('refund_transaction_id')) {
      // console.log('IDI NA REFUND>>>>>>>>');
      this.props.history.push(paths.REFUND_CREDIT_CARD, {
        transaction_id: query.get('refund_transaction_id'),
      });
    }
    this.props.nbsApiMyLocation();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    // console.log('MAININDEXCONTAINER NEXT PROPS:', nextProps, this.props, this.state);
    if (
      nextProps.myLocation.status === 'success' &&
      nextProps.myLocation.status !== this.props.myLocation.status
    ) {
      if (this.state.hasAffiliateParams) {
        const obj = { country: nextProps.myLocation.response.country };
        const data = prepareAffiliateParams(obj);
        // console.log('DATA TO SEND TO AFFIALIATE', data);
        setAffiliateParams({ ...this.state.affParams, ...obj });
        this.props.nbsApiTrackAffiliateClick(data);
      }
    } else if (
      nextProps.myLocation.status === 'fail' &&
      nextProps.myLocation.status !== this.props.myLocation.status
    ) {
      if (this.state.hasAffiliateParams) {
        const data = prepareAffiliateParams();
        // console.log('DATA TO SEND TO AFFIALIATE', data);
        this.props.nbsApiTrackAffiliateClick(data);
      }
    }
    if (
      nextProps.trackAffiliateClick.status === 'success' &&
      nextProps.trackAffiliateClick.status !==
        this.props.trackAffiliateClick.status
    ) {
      setLandingId(nextProps.trackAffiliateClick.response.landing_id);
    }

    if (
      nextProps.checkConfirmEmail.status === 'success' &&
      nextProps.checkConfirmEmail.status !== this.props.checkConfirmEmail.status
    ) {
      this.toggleAlert(strings.mailIsConfirmed);
    } else if (
      nextProps.checkConfirmEmail.status === 'fail' &&
      nextProps.checkConfirmEmail.status !== this.props.checkConfirmEmail.status
    ) {
      this.toggleAlert(nextProps.checkConfirmEmail.error.error);
    }
  }

  toggleAlert = (message) => {
    if (this.delayForceLogin && this.state.showAlert) {
      this.props.nbsApiEmailLogin(this.robj);
    }
    this.setState({ showAlert: !this.state.showAlert, message });
  };

  render() {
    if (this.props.history.location.pathname === paths.SETTINGS) {
      // hack to make logout appear first after logout in settings
      return (
        <Switch>
          <PropsRoute
            path={paths.LOGOUT}
            exact
            component={LogoutContainer}
            isLandscape={this.props.isLandscape}
          />
          <PropsRoute
            path={paths.INDEX}
            exact
            component={IndexPage}
            isLandscape={this.props.isLandscape}
          />
          <Redirect to={paths.LOGOUT} />
        </Switch>
      );
    } else {
      return (
        <Fragment>
          <Switch>
            <PropsRoute
              path={paths.LOGOUT}
              exact
              component={LogoutContainer}
              isLandscape={this.props.isLandscape}
            />
            <PropsRoute
              path={paths.LOGIN}
              component={LoginContainer}
              isLandscape={this.props.isLandscape}
            />
            <PropsRoute
              path={paths.FORGOT_PASSWORD}
              component={PasswordRecoveryContainer}
              isLandscape={this.props.isLandscape}
            />
            <PropsRoute
              path={paths.NEW_PASSWORD_TOKEN}
              component={NewPasswordContainer}
              isLandscape={this.props.isLandscape}
            />
            <PropsRoute
              path={paths.SIGNUP_A}
              isLandscape={this.props.isLandscape}
              component={CreateAccountContainerA}
            />
            <PropsRoute
              path={paths.SIGNUP_B}
              isLandscape={this.props.isLandscape}
              component={CreateAccountContainerB}
            />
            <PropsRoute
              path={paths.SIGNUP_I}
              isLandscape={this.props.isLandscape}
              component={CreateAccountContainerI}
            />
            <PropsRoute
              path={paths.SIGNUP_J}
              isLandscape={this.props.isLandscape}
              component={CreateAccountContainerJ}
            />
            <PropsRoute
              path={paths.SIGNUP}
              isLandscape={this.props.isLandscape}
              component={CreateAccountContainer}
            />
            <PropsRoute
              path={paths.TERMS_OF_SERVICE}
              component={Tos}
              isLandscape={this.props.isLandscape}
            />
            <PropsRoute
              path={paths.PRIVACY_POLICY}
              component={Pp}
              isLandscape={this.props.isLandscape}
            />
            <PropsRoute
              path={paths.CONTACT_US}
              component={ContactUsContainer}
              isLandscape={this.props.isLandscape}
            />
            <PropsRoute
              path={paths.DATA_MANAGEMENT}
              component={HandlingUserData}
              isLandscape={this.props.isLandscape}
            />
            <PropsRoute
              path={paths.UNSUBSCRIBE}
              component={UnsubscribeContainer}
              isLandscape={this.props.isLandscape}
            />
            <PropsRoute
              path={paths.UNSUBSCRIBE + '.php'}
              component={UnsubscribeContainer}
              isLandscape={this.props.isLandscape}
            />
            <PropsRoute
              path={paths.ITS_MATCH}
              component={LoginContainer}
              {...this.props}
            />
            <PropsRoute
              path={paths.SETTINGS__CONTACT_US}
              component={ContactUsContainer}
              isLandscape={this.props.isLandscape}
            />
            <PropsRoute
              path={paths.SETTINGS__TERMS_OF_SERVICE}
              component={Tos}
              isLandscape={this.props.isLandscape}
              history={this.props.history}
            />
            <PropsRoute
              path={paths.SETTINGS__PRIVACY_POLICY}
              component={Pp}
              isLandscape={this.props.isLandscape}
              history={this.props.history}
            />
            <PropsRoute
              path={paths.GO_VIP}
              component={LoginContainer}
              isLandscape={this.props.isLandscape}
            />
            <PropsRoute
              path={paths.GO_VIP_BARE}
              component={LoginContainer}
              isLandscape={this.props.isLandscape}
            />
            <PropsRoute
              path={paths.NEARBY_CONNECT}
              component={LoginContainer}
              isLandscape={this.props.isLandscape}
            />
            <PropsRoute
              path={paths.WELCOME_BACK}
              component={LoginContainer}
              isLandscape={this.props.isLandscape}
            />
            <PropsRoute
              path={paths.SETTINGS__PREFERENCES}
              component={LoginContainer}
              isLandscape={this.props.isLandscape}
            />
            <PropsRoute
              path={paths.SETTINGS__NOTIFICATIONS}
              component={LoginContainer}
              session={this.props.session.token}
              getMyProfile={this.props.getMyProfile}
              isLandscape={this.props.isLandscape}
            />
            <PropsRoute
              path={paths.SETTINGS__PRIVACY_LEVEL}
              component={LoginContainer}
              isLandscape={this.props.isLandscape}
            />
            <PropsRoute
              path={paths.SETTINGS__DEACTIVATE_ACCOUNT}
              exact
              component={LoginContainer}
              isLandscape={this.props.isLandscape}
            />
            <PropsRoute
              path={paths.SETTINGS__DELETE_ACCOUNT}
              exact
              component={LoginContainer}
              isLandscape={this.props.isLandscape}
            />
            <PropsRoute
              path={paths.CHAT}
              component={LoginContainer}
              isLandscape={this.props.isLandscape}
            />
            <PropsRoute
              path={paths.VIEWED__TABS}
              component={LoginContainer}
              {...this.props}
            />
            <PropsRoute
              path={paths.VIEWED}
              component={LoginContainer}
              {...this.props}
            />
            <PropsRoute
              path={paths.QUICK_MATCH}
              component={LoginContainer}
              {...this.props}
            />
            <PropsRoute
              path={paths.NEARBY_CONNECT_SETUP}
              component={LoginContainer}
              {...this.props}
            />
            <PropsRoute
              path={paths.WHOSONLINE__TABS}
              component={LoginContainer}
              {...this.props}
            />
            <PropsRoute
              path={paths.WHOSONLINE}
              component={LoginContainer}
              {...this.props}
            />
            <PropsRoute
              path={paths.FAVORITES__TABS}
              component={LoginContainer}
              {...this.props}
            />
            <PropsRoute
              path={paths.FAVORITES}
              component={LoginContainer}
              {...this.props}
            />
            <PropsRoute
              path={paths.LIKES__TABS}
              component={LoginContainer}
              {...this.props}
            />
            <PropsRoute
              path={paths.LIKES}
              component={LoginContainer}
              {...this.props}
            />
            <PropsRoute
              path={paths.CHATS__TABS}
              component={LoginContainer}
              {...this.props}
            />
            <PropsRoute
              path={paths.CHATS}
              component={LoginContainer}
              {...this.props}
            />
            <PropsRoute
              path={paths.SEARCH__REFINE}
              component={LoginContainer}
              {...this.props}
            />
            <PropsRoute
              path={paths.SEARCH}
              component={LoginContainer}
              {...this.props}
            />
            <PropsRoute
              path={paths.MEMBER}
              component={LoginContainer}
              {...this.props}
            />
            <PropsRoute
              path={paths.PROFILE__EDIT}
              component={LoginContainer}
              {...this.props}
            />
            <PropsRoute
              path={paths.PROFILE}
              component={LoginContainer}
              {...this.props}
            />
            <PropsRoute
              path={paths.BROWSE}
              component={LoginContainer}
              {...this.props}
            />
            <PropsRoute
              path={paths.SETTINGS}
              exact
              component={LoginContainer}
              {...this.props}
            />
            <PropsRoute
              path={paths.CHECKOUT}
              component={LoginContainer}
              {...this.props}
            />
            <PropsRoute
              path={paths.MATCHES}
              component={LoginContainer}
              {...this.props}
            />
            <PropsRoute
              path={paths.REFUND_CREDIT_CARD}
              component={LoginContainer}
              {...this.props}
            />
            <PropsRoute path={paths.DEEP_LINK} component={LazyDeepLink} />
            <PropsRoute
              path={paths.DEEP_LINK_APPSTORE}
              component={LazyDeepLink}
            />
            <PropsRoute
              path={paths.DEEP_LINK + '.php'}
              component={LazyDeepLink}
            />
            <PropsRoute
              path={paths.DEEP_LINK_APPSTORE + '.php'}
              component={LazyDeepLink}
            />
            <PropsRoute
              path={paths.INDEX}
              exact
              component={IndexPage}
              isLandscape={this.props.isLandscape}
            />
            <Redirect
              from='/app/govip-pay'
              to={paths.GO_VIP_BARE + '/' + this.props.location.search}
            />
            <Redirect to={paths.INDEX} />
          </Switch>

          {this.state.showAlert ? (
            <AlertError
              dismissAlert={this.toggleAlert}
              errorMessage={this.state.message}
              btnTxt={strings.Ok}
            />
          ) : null}
        </Fragment>
      );
    }
  }
}

function mapStateToProps(state) {
  return {
    trackAffiliateClick: state.trackAffiliateClick,
    myLocation: state.myLocation,
    checkConfirmEmail: state.confirmEmail,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      setMailingIdPromo,
      nbsApiMyLocation,
      nbsApiTrackAffiliateClick,
      nbsApiEmailLogin,
      nbsApiConfirmEmail,
      resetAccountStatus,
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(MainIndexContainer);



// WEBPACK FOOTER //
// ./src/containers/MainIndex/MainIndexContainer.js